<template>
  <!-- Formulario de Vigencias -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Año Vigencia -->
      <v-col cols="12" sm="6" md="6">
        <v-select
          v-model="editedItem.AnoVigencia"
          :items="aniosVigencia"
          label="Año de Vigencia"
          :rules="[rules.required]"
          outlined
          dense
          clearable
        ></v-select>
      </v-col>

      <!-- Periodo -->
      <v-col cols="12" sm="6" md="6">
        <v-select
          v-model="editedItem.PeriodoId"
          :items="periodos"
          item-title="text"
          item-value="value"
          label="Periodo"
          :rules="[rules.required]"
          outlined
          dense
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <!-- Valor Mora -->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="ValorMora"
          label="Valor Mora"
          type="number"
          readonly
          outlined
        ></v-text-field>
      </v-col>

      <!-- Valor Restante -->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="ValorRestante"
          label="Valor Restante en Mora"
          readonly
          outlined
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Botón adicionar vigencia -->
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="ValidateCampos"
          >Adicionar Vigencia</v-btn
        >
      </v-col>
    </v-row>

    <v-table>
      <thead>
        <tr>
          <th>Año</th>
          <th>Periodo</th>
          <th>Realiza Pago</th>
          <th>Valor Pago</th>
          <th>Deshabilitar Vigencia</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in vigencias" :key="index">
          <td>{{ item.AnoVigencia }}</td>
          <td>{{ item.PeriodoId }}</td>
          <td>
            <v-checkbox
              @change="onPagoChange(item)"
              v-model="item.Pago"
              hide-details
            ></v-checkbox>
          </td>
          <td>
            <v-text-field
              v-model="item.ValorMora"
              label="Valor Pagado"
              type="number"
              :readonly="!item.Pago"
              dense
            ></v-text-field>
          </td>
          <td>
            <v-switch
              v-model="item.Estado"
              :label="item.Estado ? 'Activo' : 'Inactivo'"
              inset
            ></v-switch>
          </td>
        </tr>
      </tbody>
    </v-table>

    <!-- Botón Guardar -->
    <div align="right" class="mt-4">
      <v-btn size="x-large" color="green" text @click="ConfirmacionSave">
        Guardar
      </v-btn>
    </div>

    <!-- Progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import {
  getVigenciasMora,
  upsertVigenciasMora,
} from "@/views/TCI/ActivosO/VigenciasMora/VigenciasMoraService";
export default {
  name: "vigencias_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
    },
    infoedit: {
      type: Object,
      default: [],
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    infollaves: {
      type: Object,
      default: [],
      Description: "Información de llaves",
    },
    Exito: {
      type: String,
      default: "",
    },
  },
  data() {
    const anioActual = new Date().getFullYear();
    return {
      progreso: false,
      buttonSave: false,
      anioActual: anioActual,
      aniosVigencia: Array.from({ length: 10 }, (_, i) => anioActual - i),
      periodos: Array.from({ length: 12 }, (_, i) => ({
        text: `Periodo (${i + 1})`,
        value: i + 1,
      })),
      headers: [
        { title: "#", key: "VigenciaId" },
        { title: "Año", key: "AnoVigencia" },
        { title: "Periodo", key: "PeriodoId" },
        { title: "Realiza Pago", key: "Pago" },
        { title: "Valor Pago", key: "ValorMora" },
        { title: "Deshabilitar Vigencia", key: "Estado" },
      ],
      vigencias: [],
      ValorMora: 0,
      ValorRestante: 0,
      editedItem: {
        AnoVigencia: anioActual,
        PeriodoId: null,
        Ref1: null,
        ServicioID: null,
        SoporteID: null,
        Pago: false,
        ValorMora: null,
        Estado: true,
      },
      defaultItem: {
        AnoVigencia: anioActual,
        PeriodoId: null,
        Ref1: null,
        ServicioID: null,
        SoporteID: null,
        Pago: false,
        ValorMora: null,
      },
      modelfiltro: [
        {
          campo: "Ref1",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Activo:",
        },
        {
          campo: "ServicioID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Servicio:",
        },
        {
          campo: "SoporteID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "SoporteID:",
        },
      ],
      rules: {
        required: (v) => !!v || "Campo obligatorio",
      },
      vigenciasKey: 0,
    };
  },
  methods: {
    // Validación
    ValidateCampos() {
      if (!this.editedItem.AnoVigencia || !this.editedItem.PeriodoId) {
        this.$swal({
          icon: "warning",
          title: "Campos incompletos",
          html: "Debe seleccionar año y periodo.",
        });
        this.$refs.form.validate();
        return;
      }
      this.adicionarVigencia();
    },

    // Simula guardar la vigencia
    async postRegistro() {
      this.progreso = true;
      setTimeout(() => {
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: "Las vigencias se guardaron correctamente.",
        });
        this.progreso = false;
      }, 1200);
    },

    // Agregar vigencia
    adicionarVigencia() {
      const userperfil = this.$store.getters.userperfil;
      const User = userperfil.userInfo.Usuario_ID;

      const nueva = {
        AnoVigencia: this.editedItem.AnoVigencia,
        PeriodoId: this.editedItem.PeriodoId || 1,
        ValorMora: this.editedItem.ValorMora || 0,
        Pago: false,
        VigenciaId: 0,
        Usuario: User,
        Ref1: this.infollaves.Ref_1,
        ServicioID: this.infollaves.IDServicio,
        SoporteID: this.infollaves.Secuencia_ID,
        Estado: true, // 👈 activo por defecto
      };

      // Validar duplicado
      const existe = this.vigencias.some(
        (v) =>
          v.AnoVigencia == this.editedItem.AnoVigencia &&
          v.PeriodoId == this.editedItem.PeriodoId
      );

      if (existe) {
        this.$swal({
          icon: "warning",
          title: "Vigencia duplicada",
          html: `Ya existe una vigencia con el año <b>${this.editedItem.AnoVigencia}</b> y el período <b>${this.editedItem.PeriodoId}</b>.`,
        });
        return;
      }

      // Agregar y forzar reactividad
      this.vigencias.push(nueva);
      this.vigenciasKey++;
      console.log(this.vigencias);

      this.editedItem = { ...this.defaultItem };
    },

    // Si el checkbox se desmarca, limpiar el valor
    onPagoChange(item) {
      if (!item.Pago) {
        item.ValorMora = null;
      }
    },

    // Cargar datos si se está editando
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        this.editedItem = this.infoedit;
      }
    },

    // Parametros Iframe
    parametrosiframe() {
      // Ref 1
      if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
        this.modelfiltro[0].contenido = this.infollaves.Ref_1;
        this.modelfiltro[0].lectura = true;
        this.modelfiltro[0].clear = false;
        this.modelfiltro[0].filtro = "=";
      }

      // Servicio Id
      if (
        this.infollaves.IDServicio != null &&
        this.infollaves.IDServicio != ""
      ) {
        this.modelfiltro[1].contenido = this.infollaves.IDServicio;
        this.modelfiltro[1].lectura = true;
        this.modelfiltro[1].clear = false;
        this.modelfiltro[1].filtro = "=";
      }

      // Soporte Id
      if (
        this.infollaves.Secuencia_ID != null &&
        this.infollaves.Secuencia_ID > 0
      ) {
        this.modelfiltro[2].contenido = this.infollaves.Secuencia_ID.toString();
        this.modelfiltro[2].lectura = true;
        this.modelfiltro[2].clear = false;
        this.modelfiltro[2].filtro = "=";
      }

      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.getConsultData();
    },

    // Get Consulta Data
    async getConsultData() {
      this.vigencias = [];
      this.progreso = true;

      const data = {
        busquedacompleta: true,
        parametro1: null,
        filtrado: this.modelfiltro,
        parametro2: null,
      };

      try {
        const result = await getVigenciasMora(data);
        this.vigencias = result;
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Confirmación de Guardado
    ConfirmacionSave() {
      if (this.vigencias.length > 0 && this.vigencias != null) {
        this.$swal({
          icon: "question",
          title: "Confirmación Información",
          html: "¿Está seguro que desea guardar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.upsertData();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },

    // Post Register Data (Upsert)
    async upsertData() {
      this.progreso = true;
      try {
        const result = await upsertVigenciasMora(this.vigencias);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },
  },
  mounted() {
    this.parametrosiframe();
    this.ActualizarCargue();
  },
};
</script>
